export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-zurb-49ec787f38935afcc138cbb95acb828c.svg";